export const isGuestDataStored = (): boolean => {
    try {
        const guestDataStr = localStorage.getItem("guest-data");
        if (!guestDataStr) {
            return false;
        }

        const guestData = JSON.parse(guestDataStr);
        // Check that guestData is an object, not null, and has at least one property.
        return (
            typeof guestData === "object" &&
            guestData !== null &&
            Object.keys(guestData).length > 0
        );
    } catch (error) {
        console.error(
            "Local storage is not accessible or guest-data is invalid:",
            error
        );
        return false;
    }
};
